(function ($, window, doc) {
    'use strict';

    var $html = $("html"), $win = $(window);

    $.support.transition = (function () {

        var transitionEnd = (function () {

            var element = doc.body || doc.documentElement,
                transEndEventNames = {
                    WebkitTransition: 'webkitTransitionEnd',
                    MozTransition: 'transitionend',
                    OTransition: 'oTransitionEnd otransitionend',
                    transition: 'transitionend'
                }, name;

            for (name in transEndEventNames) {
                if (element.style[name] !== undefined) { return transEndEventNames[name]; }
            }
        }());

        return transitionEnd && { end: transitionEnd };
    })();

    $.support.animation = (function () {

        var animationEnd = (function () {

            var element = doc.body || doc.documentElement,
                animEndEventNames = {
                    WebkitAnimation: 'webkitAnimationEnd',
                    MozAnimation: 'animationend',
                    OAnimation: 'oAnimationEnd oanimationend',
                    animation: 'animationend'
                }, name;

            for (name in animEndEventNames) {
                if (element.style[name] !== undefined) { return animEndEventNames[name]; }
            }
        }());

        return animationEnd && { end: animationEnd };
    })();

    $.support.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function (callback) { window.setTimeout(callback, 1000 / 60); };
    $.support.touch = (
        ('ontouchstart' in window && navigator.userAgent.toLowerCase().match(/mobile|tablet/)) ||
        (window.DocumentTouch && document instanceof window.DocumentTouch) ||
        (window.navigator['msPointerEnabled'] && window.navigator['msMaxTouchPoints'] > 0) || //IE 10
        (window.navigator['pointerEnabled'] && window.navigator['maxTouchPoints'] > 0) || //IE >=11
        false
    );
    $.support.mutationobserver = (window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver || null);

    $.Utils = {};

    $.Utils.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) { func.apply(context, args); }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) { func.apply(context, args); }
        };
    };

    $.Utils.removeCssRules = function (selectorRegEx) {
        var idx, idxs, stylesheet, _i, _j, _k, _len, _len1, _len2, _ref;

        if (!selectorRegEx) { return; }

        setTimeout(function () {
            try {
                _ref = document.styleSheets;
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    stylesheet = _ref[_i];
                    idxs = [];
                    stylesheet.cssRules = stylesheet.cssRules;
                    for (idx = _j = 0, _len1 = stylesheet.cssRules.length; _j < _len1; idx = ++_j) {
                        if (stylesheet.cssRules[idx].type === CSSRule.STYLE_RULE && selectorRegEx.test(stylesheet.cssRules[idx].selectorText)) {
                            idxs.unshift(idx);
                        }
                    }
                    for (_k = 0, _len2 = idxs.length; _k < _len2; _k++) {
                        stylesheet.deleteRule(idxs[_k]);
                    }
                }
            } catch (_error) { }
        }, 0);
    };

    $.Utils.isInView = function (element, options) {

        var $element = $(element);

        if (!$element.is(':visible')) {
            return false;
        }

        var window_left = $win.scrollLeft(),
            window_top = $win.scrollTop(),
            offset = $element.offset(),
            left = offset.left,
            top = offset.top;

        options = $.extend({ topoffset: 0, leftoffset: 0 }, options);

        if (top + $element.height() >= window_top && top - options.topoffset <= window_top + $win.height() &&
            left + $element.width() >= window_left && left - options.leftoffset <= window_left + $win.width()) {
            return true;
        } else {
            return false;
        }
    };

    $.Utils.options = function (string) {

        if ($.isPlainObject(string)) { return string; }

        var start = (string ? string.indexOf("{") : -1), options = {};

        if (start != -1) {
            try {
                options = (new Function("", "var json = " + string.substr(start) + "; return JSON.parse(JSON.stringify(json));"))(); // jshint ignore:line
            } catch (e) { }
        }

        return options;
    };

    $.Utils.events = {};
    $.Utils.events.click = $.support.touch ? 'tap' : 'click';

    $.langdirection = $html.attr("dir") == "rtl" ? "right" : "left";

    $(function () {

        // Check for dom modifications
        if (!$.support.mutationobserver) { return; }

        // Install an observer for custom needs of dom changes
        var observer = new $.support.mutationobserver($.Utils.debounce(function (mutations) {
            $(doc).trigger("domready");
        }, 300));

        // pass in the target node, as well as the observer options
        observer.observe(document.body, { childList: true, subtree: true });

    });

    // add touch identifier class
    $html.addClass($.support.touch ? "touch" : "no-touch");

}(jQuery, window, document));
/**=========================================================
 * Module: play-animation.js
 * Provides a simple way to run animation with a trigger
 * Targeted elements must have
 *   [data-toggle="play-animation"]
 *   [data-target="Target element affected by the animation"]
 *   [data-play="Animation name (http://daneden.github.io/animate.css/)"]
 *
 * Requires animo.js
 =========================================================*/

(function ($, window, document) {
    'use strict';

    var Selector = '[data-toggle="play-animation"]';

    $(function () {

        var $scroller = $(window).add('body, .wrapper');

        // Parse animations params and attach trigger to scroll
        $(Selector).each(function () {
            var $this = $(this),
                offset = $this.data('offset'),
                delay = $this.data('delay') || 100, // milliseconds
                animation = $this.data('play') || 'bounce';

            if (typeof offset !== 'undefined') {

                // test if the element starts visible
                testAnimation($this);
                // test on scroll
                $scroller.scroll(function () {
                    testAnimation($this);
                });

            }

            // Test an element visibilty and trigger the given animation
            function testAnimation(element) {
                if (!element.hasClass('anim-running') &&
                    $.Utils.isInView(element, { topoffset: offset })) {
                    element
                        .addClass('anim-running');

                    setTimeout(function () {
                        element
                            .addClass('anim-done')
                            .animo({ animation: animation, duration: 0.7 });
                    }, delay);

                }
            }

        });

        // Run click triggered animations
        $(document).on('click', Selector, function () {

            var $this = $(this),
                targetSel = $this.data('target'),
                animation = $this.data('play') || 'bounce',
                target = $(targetSel);

            if (target && target) {
                target.animo({ animation: animation });
            }

        });

    });

}(jQuery, window, document));

/**
 *
 * BeAdmin - Bootstrap Admin Theme - Page Javascript
 *
 * Author: @themicon_co
 * Website: http://themicon.co
 * License: http://support.wrapbootstrap.com/knowledge_base/topics/usage-licenses
 *
 */

(function ($, window, document) {
    'use strict';

    // Document ready
    $(function () {

        adjustPageLayout();
        $(window).on('resize', adjustPageLayout);

        // Init Fast click for mobiles
        FastClick.attach(document.body);

        // Hook into accordion show event to add an active class
        // to panel-heading. Used in page login-multi.
        var Selector = '[data-toggle="collapse-autoactive"]',
            panelHeading = '.panel-heading',
            panelHeadingActive = 'panel-heading-active';

        $(document).on('show.bs.collapse', Selector, function (e) {
            // From the panel-group, deactive all headings
            $(e.currentTarget)
                .find(panelHeading)
                .removeClass(panelHeadingActive);
            // And activate the target heading
            $(e.target)
                .siblings(panelHeading)
                .addClass(panelHeadingActive);
        });


        // ----------------------------------------------------------
        // If you need Javascript components from the application
        // do not include the file app.js in all your pages.
        // Find the module and paste the source here to keep the pages
        // lightweight and separated from the application source
        // !! Or even better use gulpfile.js to add modules for pages !!
        // ----------------------------------------------------------



    }); // end document ready


    // keeps the wrapper covering always the entire body
    function adjustPageLayout() {
        $('.page-wrapper').css('min-height', $(window).height());
    }

}(jQuery, window, document));
